export const SAVE_DEBOUNCE_MS = 800;
export const SAVED_FLASH_MS = 2000;

export function makeKey(patientId: number, stickyId: number): string {
  return `${patientId}:${stickyId}`;
}

let temporaryStickyIdCounter = 0;

export function createTemporaryStickyId(): number {
  temporaryStickyIdCounter -= 1;
  return temporaryStickyIdCounter; // Negative IDs are temporary
}

export function isTemporaryStickyId(stickyId: number): boolean {
  return stickyId < 0;
}
